import { useGateOverride, useHasGate, useHasScope, useUserInfo } from './accountsQueries';
const AO_SCOPE = 'academy-onboarding';
const AO_GATE = 'AcademyAchievements::Onboarding::LiveEvents';
const ELIGIBILITY_WINDOW_MS = 90 * 24 * 60 * 60 * 1000;
export const useHasAcademyOnboardingAccess = ({
  requireEligibilityWindow = false
} = {}) => {
  const {
    hasScope,
    gatesAndScopesLoading: scopeLoading
  } = useHasScope(AO_SCOPE);
  const {
    hasGate,
    hasGateLoading: gateLoading
  } = useHasGate(AO_GATE);
  const [gateOverride] = useGateOverride(AO_GATE);
  const {
    userInfo,
    userInfoLoading
  } = useUserInfo({
    skip: !requireEligibilityWindow
  });
  const isLoading = scopeLoading || gateLoading || requireEligibilityWindow && userInfoLoading;
  const verifiedAt = userInfo === null || userInfo === void 0 ? void 0 : userInfo.user.verifiedAt;
  const withinEligibilityWindow = !requireEligibilityWindow || gateOverride === true || verifiedAt !== undefined && Date.now() - verifiedAt <= ELIGIBILITY_WINDOW_MS;
  const hasAccess = !isLoading && hasScope === true && hasGate === true && withinEligibilityWindow;
  return {
    hasAccess,
    isLoading
  };
};